import { SrIcon } from "@/components/ui/SrIcon";

export type SortDir = "asc" | "desc";

export function SortIcon({ active, dir }: { active: boolean; dir: SortDir }) {
  if (!active) return null;
  return dir === "asc"
    ? <SrIcon name="arrow-up" className="w-3 h-3 ml-1 inline"  />
    : <SrIcon name="arrow-down" className="w-3 h-3 ml-1 inline"  />;
}
